import React, { FC, useContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import ScopeContext from '../../../components/redux/#ScopeContext';
import getWrappedDisplayName from '../../../utils/hocs/getWrappedDisplayName';

export interface WithScopeProps<S> {
  scope: string[];
  store: S;
}

/**
 * @since 0.18
 * @visibleName withScope
 * @component
 */
export default function withScope<State extends object>(WrappedComponent: FC<WithScopeProps<State>>) {
  const WithScope = (props: WithScopeProps<State>) => {
    const { scope, store } = useContext(ScopeContext);
    return <WrappedComponent scope={scope} store={store} {...props} />;
  };

  WithScope.displayName = getWrappedDisplayName('WithScope', WrappedComponent);

  return hoistNonReactStatics(WithScope, WrappedComponent);
}
